import React from 'react';
import { useSelector, RootStateOrAny } from 'react-redux';
import QRCode from 'react-qr-code';
import { AuthState } from 'store/ducks/auth';
import { AsideMenu, Clock } from 'components/Main';

import * as S from './styles';
import { BackgroundTransition } from 'components/Main';

const SHOW_TEST_ENV_WARNING =
  window.location.hostname === 'hml-basf.webcol.systems';

export const Main: React.FC = () => {
  const { data } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.auth
  );

  return (
    <S.Container>
      <AsideMenu />
      {/* <Clock /> */}
      <S.Content>
        {SHOW_TEST_ENV_WARNING && (
          <S.TestEnvWarning>Ambiente de homologação</S.TestEnvWarning>
        )}
        {!!data?.app_access && (
          <S.ItemWrapper>
            <S.Item>
              <S.Box>
                <S.AvatarSara />
                <S.Name>Sara</S.Name>
                <QRCode
                  value="https://api.whatsapp.com/send/?phone=5524999585260"
                  size={80}
                />
              </S.Box>
              <S.Text>
                Escaneie esse código para iniciar uma conversa com Sara no
                WhatsApp.
              </S.Text>
            </S.Item>
          </S.ItemWrapper>
        )}
      </S.Content>
      <BackgroundTransition />
    </S.Container>
  );
};
